var { SummaryPageNumber, InprogressOfferPageNumber } = require('../constants')

const htmlEncode = str => {
  return String(str).replace(/[^\w. ]/gi, function (c) {
    return '&#' + c.charCodeAt(0) + ';'
  })
}

const toBase64CompressJson = json => {
  const str = JSON.stringify(json)
  const strcomp = str
  // Need URL-safe encoding for characters outside Latin1
  const base64 = window.btoa(unescape(encodeURIComponent(strcomp)))
  return base64
}

const fromBase64CompressJson = base64 => {
  const strcomp = window.atob(base64)
  const str = strcomp
  let json = null

  try {
    json = JSON.parse(str)
  } catch (err) {
    console.log(str, err.message)
  }

  return json
}

const tryParseHashParams = hash => {
  let params = null
  try {
    params = fromBase64CompressJson(hash)
  } catch (e) {
    // fromBase64CompressJson may fail due to some dealers tracking implementation but we still have other work to do with other parameters
  }

  return params
}

const removeInvalidCharacters = str => {
  return str.replace(/[^a-zA-Z0-9 -\/:-@\[-\`{-~]/g, '')
}

// on server side these are all null
let initialPathParamsSet = false
let initialPathParams = []
let initialQueryParams = null
let initialQueryString = ''

const isVehicleDetailsPage = location => isLoadingSSG(location)
const isLoadingSSG = location => process.env.BUILD_STAGE === 'build-html' && location.pathname.includes('/loading')
const getProp = (prop, value) => (value ? { [prop]: value } : {})

const StringUtils = {
  isVehicleDetailsPage,
  isLoadingSSG,
  getHashParameters: hash => [hash.substring(6)],
  hasDomainRegex: url => {
    const domainRegex = new RegExp('^(?:[a-z]+:)?//', 'i')

    return domainRegex.test(url)
  },
  isValidIpAddress: ipaddress => {
    var ipv4Regex = /^(\d{1,3}\.){3,3}\d{1,3}$/
    var ipv6Regex = /^(::)?(((\d{1,3}\.){3}(\d{1,3}){1})?([0-9a-f]){0,4}:{0,2}){1,8}(::)?$/i

    return ipv4Regex.test(ipaddress) || ipv6Regex.test(ipaddress)
  },
  getUrlState: location => {
    const [stateParam] = StringUtils.getHashParameters(location ? location.hash : '#')
    let urlState = null

    if (!!stateParam) {
      urlState = tryParseHashParams(stateParam)
    }

    if (location && location.hash === '#/') {
      urlState = { go: 1 }
    }

    if (process.env.BUILD_STAGE !== 'build-html')
      if (initialPathParams.length) {
        if (urlState) {
          urlState.pa = initialPathParams
        } else {
          urlState = { pa: initialPathParams }
        }
      } else if (urlState && urlState.pa && urlState.pa.length) {
        initialPathParamsSet = true
        initialPathParams = urlState.pa
      }

    return urlState
  },
  getPathParameters: pathname => {
    let params = pathname.split('/').filter(x => !!x)
    let pathParams = []

    if (params[0] === 'instant-cash-offer') {
      params.splice(0, 1)
    }

    if (params[0] === 'links') {
      params.splice(0, 1)
    }

    if (params.length) {
      if (!/^\d{4}$/.test(params[0])) {
        pathParams = params
        params = []
      } else if (params.length > 3) {
        pathParams = params.slice(3)
        params = params.slice(0, 3)
      }
    }

    if (process.env.BUILD_STAGE !== 'build-html')
      if (!initialPathParamsSet) {
        initialPathParamsSet = true
        initialPathParams = pathParams
      }

    return { initialPathParams, params, pathParams }
  },
  toUrlDisplayName: param => {
    let resultall = encodeURIComponent(param.replace(/[^A-Z0-9]+/gi, '').toLowerCase())

    if (resultall.length > 5) {
      const result1 = resultall.substring(0, 4)
      const result2 = resultall.substring(4)
      const atEvery = result2.length > 10 ? 3 : 2
      const len = Math.floor(result2.length / atEvery)
      const newValue = new Array(len)

      for (let i = 0; i < len; i++) {
        newValue[i] = result2.charAt(i * atEvery)
      }

      resultall = result1 + newValue.join('')
    }

    return resultall
  },
  toUrlDisplayNamePath: param => encodeURIComponent(param.replace(/[^A-Z0-9]+/gi, '-').toLowerCase()),
  getPath: (...items) => {
    let path = '/'
    items
      .filter(x => !!x)
      .forEach(item => {
        path = path + StringUtils.toUrlDisplayNamePath(item) + '/'
      })
    return path
  },
  cleanString: string => (string ? string.replace(/ |\/|&/gi, '').toLowerCase() : string),
  upperCaseFirstLetter: string => string.charAt(0).toUpperCase() + string.slice(1),
  formatPhoneString: string =>
    string
      .replace('+1', '')
      .replace(/[^\d]/g, '')
      .replace(' ', '')
      .replace(/^(\d{3})(\d{3})/, '($1) $2')
      .replace(/^(\(\d{3}\) \d{3})(\d+)/, '$1-$2'),
  isZipValid: zip => {
    return /(^\d{5}$)|(^\d{5}-\d{4}$)/.test(zip)
  },
  preventTypingNumber: value => value.replace(/[0-9]/g, ''),
  phoneDigitsOnly: string => StringUtils.formatPhoneString(string).replace(/\D/g, ''),
  includesAny: (string, substrings) => substrings.some(sub => string.includes(sub)),
  startsWithAny: (string, substrings) => substrings.some(sub => string.startsWith(sub)),
  getStringValue: value => {
    return value === 'undefined' || value === 'null' || !value ? '' : value
  }
}

const ArrayUtils = {
  arrayIsEqualShallow: (a1, a2) => {
    let same = false

    if (Array.isArray(a1) && Array.isArray(a2)) {
      if (a1.length === a2.length) {
        let index = 0

        for (; index < a1.length; index++) if (a1[index] !== a2[index]) break
        same = index === a1.length
      }
    }

    return same
  },
  findLen: items => {
    let best = 2

    for (var rows = 2; rows <= Math.ceil(items / 2); rows++) {
      if ((items % rows) - rows <= 1) {
        best = rows
      }
    }

    return best
  },
  divideArray: (list, length) => {
    const arr = []
    const cp = Array.from(list)

    for (var i = 0; i < Math.ceil(list.length / length); i++) {
      arr.push(cp.splice(0, length))
    }

    return arr
  },
  deDuplicate: (items, key) => {
    try {
      return items
        .filter(i => !!i)
        .reduce((acc, current) => {
          const x = key ? acc.find(item => item[key].toLowerCase() === current[key].toLowerCase()) : acc.find(item => item.toLowerCase() === current.toLowerCase())
          if (!x) {
            return acc.concat([current])
          } else {
            return acc
          }
        }, [])
    } catch {
      return items
    }
  }
}

const QueryUtils = {
  getQuery: location => location.search,
  getQueryParameters: location => QueryUtils.parseQueryParameters(location.search),
  parseQueryParameters: search => {
    if (!!initialQueryParams) {
      return initialQueryParams
    }

    initialQueryParams =
      search && search.length
        ? search
            .slice(1) //remove ? character
            .split('&')
            .reduce((acc, cur) => {
              const [key, value] = decodeURIComponent(cur).split('=')
              return { ...acc, [key.toLowerCase()]: value }
            }, {}) // make the query list into one object with all query params
        : {}

    initialQueryString = search && search.length ? search : ''

    return initialQueryParams
  },
  getQueryParametersFromUrl: () => {
    try {
      const search = window.location.search
      const params = new URLSearchParams(search)
      let paramObj = {}
      for (var value of params.keys()) {
        paramObj[value] = params.get(value)
      }
      return paramObj
    } catch {
      return {}
    }
  },
  updateQueryParametersFromUrl: (key, value) => {
    if (typeof window !== 'undefined' && 'URLSearchParams' in window) {
      const searchParams = new URLSearchParams(window.location.search)
      const formatParams = new URLSearchParams()
      formatParams.set(key, value)
      for (const [k, v] of searchParams) {
        if (k && k.toLowerCase() !== key.toLowerCase()) {
          formatParams.set(k, v)
        }
      }
      const searchParamsString = formatParams.toString()
      const newURL = `${window.location.pathname}?${searchParamsString}${window.location.hash}`
      window.history.pushState(null, '', newURL)
      return true
    }
  },
  getInitUrlState: location => {
    const { mileage, extcolor, vin, trim } = location.initQueryParams

    return { ...getProp('m', +mileage), ...getProp('c', extcolor), ...getProp('vin', StringUtils.getStringValue(vin).toUpperCase()), ...getProp('trimName', StringUtils.getStringValue(trim).replace(/\+/g, ' ')) }
  }
}

var navigate = require('gatsby').navigate
let lastUrlState = {}
let lastMessage5 = null
const isBrowser = typeof window !== 'undefined'
const isAndroid = isBrowser && navigator.userAgent.match(/Android/i)
const isIOS = isBrowser && (navigator.userAgent.match(/iPhone|iPad|iPod/i) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) && !window.MSStream

const BrowserUtils = {
  isBrowser,
  isAndroid,
  isIOS,
  isSSG: process.env.BUILD_STAGE === 'build-html',
  isClientSide: process.env.BUILD_STAGE !== 'build-html',
  getDataLayer: () => (BrowserUtils.isClientSide && window.ICO?.dataLayer) || {},
  isIframe() {
    try {
      if (isBrowser) {
        return window.self !== window.top
      }
    } catch (e) {
      return true
    }
  },
  getIrameParrentHostname() {
    try {
      var url = window.location != window.parent.location ? document.referrer : document.location.href
      return url.replace('https://', '').replace('http://', '')
    } catch {
      return ''
    }
  },
  getIrameParrentPathname() {
    try {
      return window.top.location.pathname
    } catch {
      return undefined
    }
  },
  isIE: () => {
    return isBrowser && (navigator.userAgent.indexOf('MSIE ') > -1 || navigator.userAgent.indexOf('Trident/') > -1)
  },
  isIOSAndChrome: () => {
    return isBrowser && !!navigator.userAgent.match(/CriOS/i)
  },
  isDesktop: () => {
    const resolutions = {
      maxTablet: 1024,
      minDesktop: 1024
    }

    return (
      isBrowser &&
      ((window.matchMedia(`(orientation: portrait)`).matches && window.matchMedia(`(min-width: ${resolutions.maxTablet}px)`).matches) ||
        (window.matchMedia(`(orientation: portrait)`).matches &&
          window.matchMedia(`(min-width: ${resolutions.maxTablet}px)`).matches &&
          window.matchMedia(`(max-width: ${resolutions.minDesktop}px)`).matches &&
          window.matchMedia(`(min-height: ${resolutions.maxTablet}px)`).matches) ||
        window.matchMedia(`(min-width: ${resolutions.minDesktop}px)`).matches)
    )
  },
  isMobile: () => {
    return isBrowser && (isAndroid || isIOS || navigator.userAgent.match(/Opera Mini/i))
  },
  resizeParent: elID => {
    if (isBrowser) {
      const scope = window.top
      const bodyHeight = `${document.getElementsByTagName('html')[0].scrollHeight}px`
      const certificateMessage = {
        type: 'showAd',
        adType: 'icoCertificate',
        targetIframe: elID,
        height: bodyHeight
      }

      BrowserUtils.postMessage(JSON.stringify(certificateMessage), '*', scope)
    }
  },
  postMessage: (message, flags, scope) => {
    try {
      const last5 = message.substr(0, 5)

      if (last5 !== lastMessage5) {
        lastMessage5 = last5
      }

      scope = scope || window.parent
      scope.postMessage(message, flags)
    } catch (err) {
      console.log('parent post error', err.message)
    }
  },
  emitComponentSize: (size, location) => {
    if (size < 500) {
      if (BrowserUtils.calculateHeaderAndFooter() > 0 && location === 'certificate') {
        location = 'certificateWithHeaders'
      }
      size = BrowserUtils.getDefaultPageSize(location)
    }

    if (size < 610 && location === 'imagecapture') {
      size = BrowserUtils.getDefaultPageSize(location)
    }

    var total = size

    var headersTotal = BrowserUtils.calculateHeaderAndFooter()
    total = headersTotal + size

    const payload = { height: total, initial: false }
    BrowserUtils.postMessage(JSON.stringify(payload), '*')
    BrowserUtils.postMessage(JSON.stringify({ action: 'getFrameDetails' }), '*')
  },
  calculateHeaderAndFooter: () => {
    var total = 0
    if (typeof document !== 'undefined') {
      const header = document.getElementById('globalHeader') ? document.getElementById('globalHeader') : document.getElementsByTagName('header').length > 0 ? document.getElementsByTagName('header')[0] : null
      const headerHeight = header ? header.offsetHeight : 0
      const footer = document.getElementById('globalFooter') ? document.getElementById('globalFooter') : null
      const footerHeight = footer ? footer.offsetHeight : 0
      const helpFooter = document.getElementById('helpFooter')
      const helpFooterHeight = helpFooter ? helpFooter.offsetHeight : 0
      const navFooterHeight = document.getElementById('NavFooter') ? document.getElementById('NavFooter').offsetHeight : 0
      total = headerHeight + footerHeight + helpFooterHeight + navFooterHeight
    }
    return total
  },
  getDefaultPageSize: pageName => {
    const pages = {
      contact: 820,
      certificate: 700,
      certificateWithHeaders: 1500,
      imagecapture: BrowserUtils.isDesktop() ? 700 : 1050,
      condition: 950,
      vehicleDetails: BrowserUtils.isDesktop() ? 2500 : 5000,
      vehicleDetailsKeysMods: BrowserUtils.isDesktop() ? 2900 : 6000,
      history: BrowserUtils.isDesktop() ? 1200 : 1500
    }
    return pages[pageName]
  },
  clearLastPostMessage: () => {
    // call this if you want to make sure this gets logged to the console for QA
    lastMessage5 = null
  },
  postExpiredToken: () => {
    const payload = { GetAuthToken: true }
    BrowserUtils.postMessage(JSON.stringify(payload), '*')
  },
  addScript: function (src, location, type = 'text/javascript', async = true) {
    try {
      var scriptExists = document.querySelector('script[src*="' + src + '"]')

      if (!scriptExists) {
        var appendTo = location || document.getElementsByTagName('script')[0].parentNode
        var scriptContainer = document.createElement('script')

        scriptContainer.src = src
        scriptContainer.type = type
        scriptContainer.async = async

        appendTo.appendChild(scriptContainer)

        return true
      }
    } catch (e) {
      console.log('error loading script ' + src)
      return false
    }
  },
  postStartFca: () => {
    const payload = {
      type: 'CustomTagEvent',
      eventName: 'start',
      eventAction: 'form',
      attributes: {
        formDescription: 'lead',
        formType: 'vendor trade in tool',
        displayType: 'iframe',
        displayFormat: 'inPage',
        tradeInProvider: 'Kelley Blue Book Instant Cash Offer'
      }
    }

    BrowserUtils.postMessage(JSON.stringify(payload), '*')
  },
  postOfferFca: (offer, tradeInYear, tradeInMake, tradeInModel, rvMakesModels) => {
    const replacementVehicle = offer.prospect.replacementVehicle

    // check to see that a max year value exists or else there is no replacement vehicle
    const yearRange = replacementVehicle.find(q => q.questionId === 'qrv/YearRange')
    const desiredVehicleYear = (yearRange && yearRange.max) || ''

    // check to see if the make and model field has no value since that means there is no replacement vehicle
    let desiredVehicleMake = ''
    let desiredVehicleModel = ''
    const rvValue = replacementVehicle.find(q => q.questionId === 'qrv/MakeAndModel').subquestions.find(q => q.questionId === 'qrv/MakeModel1').value

    if (rvValue && rvMakesModels) {
      const selectedRvMakeValue = rvValue.split('/').slice(0, 2).join('/')
      const selectedRvMake = rvMakesModels.find(q => q.id === selectedRvMakeValue)

      if (selectedRvMake) {
        desiredVehicleMake = selectedRvMake.label
        // match the full value sent into Edge to get the model name
        desiredVehicleModel = selectedRvMake.values.find(q => q.id === rvValue).label
      }
    }

    const payload = {
      type: 'CustomTagEvent',
      eventName: 'submit',
      eventAction: 'form',
      attributes: {
        formDescription: 'lead',
        formType: 'vendor trade in tool',
        leadId: offer.offerId,
        displayType: 'iframe',
        displayFormat: 'inPage',
        tradeInProvider: 'Kelley Blue Book Instant Cash Offer',
        tradeInVehicleYear: tradeInYear.displayName,
        tradeInVehicleMake: tradeInMake.displayName,
        tradeInVehicleModel: tradeInModel.displayName,
        desiredVehicleYear: desiredVehicleYear,
        desiredVehicleMake: desiredVehicleMake,
        desiredVehicleModel: desiredVehicleModel
      }
    }
    BrowserUtils.postMessage(JSON.stringify(payload), '*')
  },
  postOfferComplete: (offerId, email) => {
    const payload = {
      ShowCertificate: true,
      OfferGuid: offerId,
      Email: email
    }
    BrowserUtils.postMessage(JSON.stringify(payload), '*')
  },
  postOfferCompleteGoogleAnalytics: offerId => {
    const payload = {
      type: 'Google_Analytics',
      payload: {
        nonInteractive: true,
        ni: true,
        certifacte: true,
        offerId
      }
    }
    BrowserUtils.postMessage(JSON.stringify(payload), '*')
  },
  postEditComplete: (offerId, email) => {
    const payload = {
      ShowAssessment: true,
      CloseFrame: true,
      ShowCertificate: true,
      OfferGuid: offerId,
      Email: email
    }
    BrowserUtils.postMessage(JSON.stringify(payload), '*')
  },
  postOfferCompleteCobranding: (offer, markupAmount) => {
    const prospect = offer && offer && offer.prospect
    const now = new Date()
    const payload = prospect && {
      type: 'EXTERNAL_TRADE_ADDED',
      payload: {
        KBBVehicleId: prospect.vehicle.trimId,
        email: prospect.contactInfo.email,
        firstName: prospect.contactInfo.firstName,
        lastName: prospect.contactInfo.lastName,
        vin: prospect.vehicle.vin || '',
        make: prospect.vehicle.vehicleDescription.make,
        markupAmount: markupAmount || 0,
        mileage: prospect.mileage,
        model: prospect.vehicle.vehicleDescription.model,
        offerDate: now.toISOString(),
        offerExpirationDate: offer.expirationDate,
        offerId: offer.offerId,
        phone: prospect.contactInfo.phone,
        status: offer.status,
        tivSource: 'ICO',
        trim: prospect.vehicle.vehicleDescription.trim,
        value: offer.amount,
        year: prospect.vehicle.vehicleDescription.year,
        zip: prospect.contactInfo.zip,
        primaryBodyStyle: offer.primaryBodyStyle
      }
    }

    BrowserUtils.postMessage(JSON.stringify(payload), '*')
  },
  postDuplicateOffer: (duplicateOfferId, duplicateUserId) => {
    const payload = {
      OfferGuid: duplicateOfferId,
      DealerId: duplicateUserId,
      CloseFrame: true,
      DupCheck: true
    }
    BrowserUtils.postMessage(JSON.stringify(payload), '*')
  },
  getInitParams: () => ({ initialPathParams, initialQueryParams, initialQueryString }),
  removeInitQueryParam: param => {
    if (initialQueryString) {
      const index1 = initialQueryString.toLowerCase().indexOf(param.toLowerCase() + '=')
      const index2 = initialQueryString.toLowerCase().indexOf('&', index1)

      if (index1 >= 0) {
        initialQueryString = initialQueryString.substring(0, index1) + (index2 > 0 ? initialQueryString.substring(index2 + 1) : '')
      }
    }

    for (const property in initialQueryParams) {
      if (property.toLowerCase() === param.toLowerCase()) {
        delete initialQueryParams[property]
      }
    }
  },
  updateInitQueryParam: (param, value) => {
    BrowserUtils.removeInitQueryParam(param)

    if (initialQueryString && initialQueryString.charAt(0) === '?') {
      initialQueryString = '?' + param + '=' + value + '&' + initialQueryString.substring(1)
    } else {
      initialQueryString = '?' + param + '=' + value
    }

    initialQueryParams[param] = value
  },
  removeInitPathParam: param => {
    const index = initialPathParams.findIndex(iparam => iparam === param)

    if (index >= 0) {
      initialPathParams[index] = 'removed'
    }
  },
  getUrlStateLink: ({ year = {}, make = {}, model = {}, urlState = {}, updateState = {} }, nohash, setLast = false, endhash) => {
    let hash = ''

    if (process.env.BUILD_STAGE !== 'build-html') {
      const newState = { ...urlState, ...updateState }
      if (!nohash) {
        if (initialPathParamsSet) {
          newState.pa = initialPathParams
        } else if (newState.pa) {
          initialPathParams = newState.pa
        }
        if (setLast) {
          lastUrlState = newState
        }

        hash = '#_____' + toBase64CompressJson(newState)
      }
    }

    return StringUtils.getPath(year.displayName, make.displayName, model.displayName) + initialQueryString + (nohash ? (endhash ? '#/' : '') : hash)
  },
  setHistoryUrlState: urlState => {
    if (!Object.keys(lastUrlState).length && ((urlState.p && urlState.p > 0) || urlState.lp)) lastUrlState = urlState
  },
  navigateToLink: (link, options = {}) => {
    navigate(link, options)
  },
  navigateToReviewInit: ({ year = {}, make = {}, model = {}, urlState = {} }) => {
    const updateState = { pp: (lastUrlState.pp || 0) + 1, pa: ['reviewoffer'], p: SummaryPageNumber }
    const state = { scroll: 1 }
    BrowserUtils.navigateWithUrlState({ year, make, model, urlState, updateState }, state)
  },
  navigateWithUrlState: ({ year = {}, make = {}, model = {}, urlState = {}, updateState = {} }, state, initPath) => {
    const { p, prospectId } = updateState
    const link = p === InprogressOfferPageNumber && prospectId ? BrowserUtils.getUrlProspectLink(prospectId) : BrowserUtils.getUrlStateLink({ year, make, model, urlState, updateState }, !!initPath, true)
    const currentUrlStep = {
      urlCurrentStep: link
    }
    BrowserUtils.postMessage(JSON.stringify(currentUrlStep), '*')
    BrowserUtils.navigateToLink(initPath ? initPath + link : link, { state: { ...state, click: true } })
  },
  navigateWithLastUrlState: ({ year = {}, make = {}, model = {}, updateState = {} }, state, initPath) => {
    const link = BrowserUtils.getUrlStateLink({ year, make, model, urlState: lastUrlState, updateState }, !!initPath, true)
    BrowserUtils.navigateToLink(initPath ? initPath + link : link, { state: { ...state, click: true } })
  },
  navigateToOffer: offer => {
    navigate('/offer/' + offer.offerId + '/' + initialQueryString, { state: { scroll: 1, click: true, offer } })
  },
  getUrlProspectLink: prospectId => {
    return '/prospect/' + prospectId + '/' + initialQueryString
  }
}

const StorageUtils = {
  isAllowed() {
    try {
      return !!sessionStorage
    } catch (e) {
      return false
    }
  },
  setWithExpiration: (key, value, expiry) => {
    value = { value, expiry }

    if (isBrowser) {
      try {
        window.sessionStorage.setItem(key, JSON.stringify(value))
      } catch (e) {
        console.log('Permission Denied')
      }
    }
  },
  setWithOneDayExpiration: (key, value) => {
    const today = new Date()
    const tomorrow = new Date()
    StorageUtils.setWithExpiration(key, value, tomorrow.setDate(today.getDate() + 1))
  },
  setProspectWithOneDayExpiration: (value, offerId) => {
    StorageUtils.setWithOneDayExpiration('prospect' + (offerId || ''), value)
  },
  getWithExpiration: key => {
    let value = undefined

    if (isBrowser) {
      try {
        value = window.sessionStorage.getItem(key)
      } catch (e) {
        console.log('Permission Denied')
      }
    }

    if (value) {
      value = JSON.parse(value)
      const expired = new Date(value.expiry).getTime() < new Date().getTime()

      return !expired && value.value
    }

    return undefined
  },
  getProspectWithExpiration: offerId => {
    return StorageUtils.getWithExpiration('prospect' + (offerId || ''))
  },
  clearProspect: offerId => {
    if (isBrowser) {
      try {
        window.sessionStorage.removeItem('prospect' + (offerId || ''))
      } catch (e) {
        console.log('Permission Denied')
      }
    }
  }
}

const QuestionUtils = {
  getQuestionLabelAndChoices: questionObject => {
    const { label, questionType, questionId, selectChoices, enumChoices } = questionObject

    const questionLabel = label

    let questionChoices =
      selectChoices &&
      selectChoices.reduce((acc, cur) => {
        acc.push(cur.value)
        return acc
      }, [])

    questionChoices = questionType === 'ToggleSelect' ? [true, false] : questionChoices
    questionChoices = questionType === 'Boolean' ? [true, false] : questionChoices
    questionChoices = questionType === 'Enum' ? enumChoices : questionChoices

    return { questionLabel, questionId, questionChoices }
  },
  mapOfferToQuestionAnswer: (questionId, question) => {
    if (question && !question.questionId.startsWith('qrv')) {
      if (question.questionType === 'SingleSelect') {
        return question.selectChoices.findIndex(choice => choice.selected)
      } else if (question.questionType === 'MultiSelect') {
        return question.selectChoices.find(choice => choice.qRef === questionId).selected && 0
      } else if (question.questionType === 'ToggleSelect') {
        return question.value && question.value !== 'False' && 0
      } else if (question.questionType === 'Integer') {
        return parseInt(question.value, 10)
      } else if (question.questionType === 'Boolean') {
        return question.value ? 0 : 1
      } else if (question.questionType === 'Enum') {
        return question.enumChoices.findIndex(enumchoice => enumchoice === question.value)
      }
    } else if (question && question.questionId.startsWith('qrv')) {
      if (question.questionType === 'Enum') {
        return question.value
      } else if (question.questionType === 'IntegerRange') {
        return `${question.max},${question.min}`
      } else if (question.questionType === 'Subquestion') {
        const subQuestion = question.subquestions.find(subquestion => questionId === subquestion.questionId) || {}
        return subQuestion.value ? 0 : undefined
      }
    }
  },
  mapOfferToQuestionComment: (questionId, question) => {
    if (question && !question.questionId.startsWith('qrv')) {
      if (question.questionType === 'SingleSelect') {
        return question.selectChoices.find(choice => choice.selected) && question.selectChoices.find(choice => choice.selected).comment
      } else if (question.questionType === 'MultiSelect') {
        return question.selectChoices.find(choice => choice.qRef === questionId) && question.selectChoices.find(choice => choice.qRef === questionId).comment
      } else if (question.questionType === 'ToggleSelect') {
        return question.comment
      } else if (question.questionType === 'Integer') {
        return question.comment
      } else if (question.questionType === 'Boolean') {
        return question.comment
      } else if (question.questionType === 'Enum') {
        return question.comment
      }
    } else if (question && question.questionId.startsWith('qrv')) {
      if (question.questionType === 'Enum') {
        return question.value
      } else if (question.questionType === 'IntegerRange') {
        return `${question.min},${question.max}`
      } else if (question.questionType === 'Subquestion') {
        return question.subquestions.find(subquestion => questionId === subquestion.questionId).value
      }
    }
  },
  translateName: itemName => {
    return itemName === 'Door' ? 'FrontDoor' : itemName === 'Seats' ? 'FrontSeats' : itemName
  },
  getAssociatedQuestions: (questions, itemName, subsectionCode) => {
    return questions
      .filter(question => !subsectionCode || StringUtils.cleanString(question.subsectionCode) === StringUtils.cleanString(subsectionCode))
      .filter(question => StringUtils.cleanString(question.item).startsWith(StringUtils.cleanString(itemName)) || StringUtils.cleanString(itemName).startsWith(StringUtils.cleanString(question.item)))
  },
  getSubsectionCodes: questions =>
    Array.from(
      questions.reduce((acc, question) => {
        return acc.add(question.subsectionCode)
      }, new Set())
    ).filter(item => !!item),
  getItems: (questions, subsectionCode) => {
    return Array.from(
      QuestionUtils.getAssociatedQuestions(questions, '', subsectionCode).reduce((acc, question) => {
        question.item = question.item === 'Rear Seats' ? 'Rear Seat' : question.item
        return acc.add(StringUtils.cleanString(question.item))
      }, new Set())
    )
  },
  isQuestionAnswered: answer => !(answer === null || answer === undefined || answer === false),
  getQx: qxData => {
    // rewrite to come from global state
    return (
      isBrowser &&
      typeof navigator !== 'undefined' &&
      typeof document !== 'undefined' && [
        {
          questionId: 'qx/IncomingURL',
          value: qxData.incomingUrl
        },
        {
          questionId: 'qx/BrowserType',
          value: navigator.userAgent
        },
        {
          questionId: 'qx/HttpReferer',
          value: document.referrer
        },
        {
          questionId: 'qx/AutotraderCarID',
          value: qxData.car_id || qxData.carid || ''
        },
        {
          questionId: 'qx/LandingPage',
          value: qxData.lp ? qxData.lp : ''
        },
        {
          questionId: 'qx/Asset',
          value: qxData.asset ? qxData.asset : ''
        },
        {
          questionId: 'qx/LnxCode',
          value: qxData.lnx ? qxData.lnx : ''
        },
        {
          questionId: 'qx/ExpCode',
          value: qxData.xpcode ? qxData.xpcode : ''
        },
        {
          questionId: 'qx/ReturnerID',
          value: qxData.returnerid ? qxData.returnerid : ''
        },
        {
          questionId: 'qx/ExtRefID',
          value: qxData.extrefid ? qxData.extrefid : ''
        }
      ]
    )
  },
  getIpQuestion: ip => ({ questionId: 'qx/IPAddress', value: ip || '172.0.0.1' }),
  getMileageEligibleOfferQuestion: mileage => ({ questionId: 'qx/EditMileageIneligibleOffer', value: mileage })
}

const ErrorUtils = {
  translateError: errorCode => {
    const errorType = ErrorUtils.getErrorType(errorCode)
    return ErrorUtils.getErrorMessage(errorType || 'genericErrors')
  },
  getErrorType: errorCode => {
    const errorCodes = ErrorUtils.getErrorCodes()
    const errorType = Object.keys(errorCodes).find(errorType => errorCodes[errorType].includes(+errorCode))
    return errorType
  },
  getErrorCodes: () => {
    return {
      historyErrors: [400050, 400051, 400052, 400053, 400054, 400055, 400056, 400057, 400058, 400059, 400091],
      contactErrors: [400080, 400081, 400083, 400085, 400092],
      emailErrors: [400082],
      phoneErrors: [400084],
      vehicleErrors: [400001, 400060, 400110, 400011, 400012, 400013, 400014, 400015, 400016, 400017, 400018, 400019, 400020, 400021, 400022, 400023, 400024, 400025, 400026, 400030],
      genericErrors: [400111, 400114, 400106, 400107, 400207, 500000, 404000, 400008, 400122],
      unsupportedUsageErrors: [400094],
      exceedOffersPerVIN: [400095],
      exceedOffersPerPhoneOrEmail: [400096, 400097],
      conditionErrors: [400061, 400062],
      offerErrors: [400100, 400101, 404103, 400105],
      offerAlreadyProcessedErrors: [400093],
      rvErrors: [400300, 400305, 400310, 400311, 400312, 400320, 400321, 400322, 400323, 400324, 400325, 400326, 400327, 400328, 400329, 400330, 400335, 400340, 400345, 400350, 400355, 400360, 400365, 400370, 400371, 400372, 400373, 400374],
      dealerErrors: [400074, 400101, 400224, 400229, 400300, 400090, 403001, 403002, 403003, 403004],
      dealerRepErrors: [400227, 400228]
    }
  },
  getErrorMessage: errorType => {
    const errorMessages = {
      historyErrors: 'We found a problem with the Vehicle History Page. Please visit that page and check for errors.',
      contactErrors: 'We found a problem with the Contact Page. Please provide all required information and try again.',
      emailErrors: 'We found a problem with the Email Address. Please use the Contact Information edit link to update it.',
      phoneErrors: 'We found a problem with the Phone Number. Please use the Contact Information edit link to update it.',
      vehicleErrors: 'We found a problem with the Vehicle Details Page. Please visit that page and check for errors.',
      genericErrors: 'We found a problem processing your Offer. Please wait a moment, then try again.',
      conditionErrors: 'We found a problem with one of the Vehicle Condition Pages. Please visit those pages and check for errors.',
      offerErrors: 'We found a problem processing your Offer. Please wait a moment, then try again.',
      offerAlreadyProcessedErrors: 'This Offer was already processed. Please check your email for the details.',
      rvErrors: 'We found a problem with your Replacement Vehicle selection. Please check the information and try again.',
      dealerErrors: 'Please wait a minute and retry',
      dealerRepErrors: 'Please provide a valid sales representative.',
      unsupportedUsageErrors: "It looks like you've tried to create several different Instant Cash Offers. If you're having trouble, need assistance, or are interested in becoming a Participating Dealer, call 866-559-5268.",
      exceedOffersPerVIN: 'There is already an offer for this vehicle. Please contact the dealer to make any needed changes.',
      exceedOffersPerPhoneOrEmail: 'There are multiple ICO offers based on the information provided. Please contact the dealer to make any needed changes.'
    }
    return errorMessages[errorType]
  }
}

exports.QuestionUtils = QuestionUtils
exports.QueryUtils = QueryUtils
exports.ArrayUtils = ArrayUtils
exports.StringUtils = StringUtils
exports.BrowserUtils = BrowserUtils
exports.StorageUtils = StorageUtils
exports.ErrorUtils = ErrorUtils
exports.fromBase64CompressJson = fromBase64CompressJson
exports.htmlEncode = htmlEncode
exports.removeInvalidCharacters = removeInvalidCharacters
